/* eslint-disable no-multi-assign */ // ok in reducers
import * as types from 'constants/action_types'

const reducers = {}
const defaultState = { byId: {} }

// Currently the only action that needs to track request IDs
reducers[types.CREATE_CHANGESET_REQUEST] = reducers[
  types.CREATE_CHANGESET_SUCCESS
] = reducers[types.DELETE_TICKETS_STARTED] = reducers[
  types.DELETE_TICKETS_SUCCESS
] = reducers[types.MERGE_TICKETS_REQUEST] = reducers[
  types.MERGE_TICKETS_COMPLETE
] = (state, action) => {
  const { requestId } = action && action.meta
  if (!requestId) return state || defaultState
  const { byId } = state

  const newById = { ...byId }
  newById[requestId] = { id: requestId }

  return {
    ...state,
    byId: newById,
  }
}

export default function reducer(state = defaultState, action) {
  // this is here because a long reducer with many ifs is unreadable
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
